import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Box, Link, Typography } from '@mui/material';

import {
  checkPaymentSourceBucket,
  checkPaymentSourceLabel,
  getCheckPaymentRelatedLink,
} from '../../utils/checkPaymentSourceLink';

interface CheckPaymentSourceCellProps {
  checkSource?: string;
  sourceId?: string;
}

export default function CheckPaymentSourceCell({
  checkSource,
  sourceId,
}: CheckPaymentSourceCellProps): React.JSX.Element {
  const bucket = checkPaymentSourceBucket(checkSource);
  const label = checkPaymentSourceLabel(bucket);
  const relatedLink = getCheckPaymentRelatedLink({
    check_source: checkSource,
    source_id: sourceId,
  });

  return (
    <Box>
      <Typography variant="body2">{label}</Typography>
      {relatedLink && (
        <Link
          component={RouterLink}
          to={relatedLink.href}
          variant="body2"
          underline="hover"
        >
          {relatedLink.label}
        </Link>
      )}
    </Box>
  );
}
